import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { equal } from '@ember/object/computed';
import { ApplicationFlow } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow';
import * as Model from '@square/dashboard-protos/models/squareup/legalentities/model/model';

export default class IneligibleController extends Controller {
  @service currentApplicationFlow;
  @service intl;

  @equal(
    'currentApplicationFlow.ineligibleReason',
    ApplicationFlow.IneligibleReason.OFAC_HIT
  )
  isManualReview;

  @equal(
    'currentApplicationFlow.ineligibleReason',
    ApplicationFlow.IneligibleReason.NON_SOLE_PROP
  )
  isNonSoleProp;

  get businessType() {
    const typeEnum = this.currentApplicationFlow.business.businessType;
    const type = Object.keys(Model.Business.Structure.Type).find(
      (key) => Model.Business.Structure.Type[key] === typeEnum
    );

    // eslint-disable-next-line square/no-translation-key-interpolation
    return this.intl.t(`banking.enums.entityType.${type}`);
  }
}
